<template>
  <transition name="fade">
    <div v-if="popup">
      <div class="pop-up-bg" @click.prevent="$emit('close')"></div>
      <div class="pop-up">
        <a class="pop-up__close icon icon-close" @click.prevent="$emit('close')"></a>
        <h2>{{$root.langText.changes.clientsSource}}</h2>
        <Search :filterNone="'none'" @inputchange="searchBtn"/>
        <p class="list-not" v-if="listNot">{{$root.langText.notFound}}</p>
        <ul class="pop-up__list">
          <li
            v-for="(source, index) in clientsSources"
            :key="index"
            :data-id="source.id"
            @click.prevent="$emit('close', {id: source.id, name: source.name, input: input})"
          >
            <div class="pop-up__list__row">
              {{source.name}}
            </div>
            <div class="decor-line"></div>
          </li>
        </ul>
        <Pagination v-if="quantityList && quantityList > params.limit" @pagination="pagination" :dataList="{quantityList, params}"/>
      </div>
    </div>
  </transition>
</template>


<style lang="scss">
  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
  }
  .fade-enter, .fade-leave-to{
    opacity: 0;
  }
  .pop-up__list li .decor-line{
    margin: 0;
  }
  .pop-up__list li img{
    height: 15px;
    margin-right: 10px;
  }

</style>


<script>
import Pagination from "@/components/app/Pagination"
import Search from "@/components/app/Search"

export default {
  props: ['popup', 'input'],

  data:() => ({
    clientsSources: [],
    quantityList: '',
    //pagination
    params: {
      start: 0, 
      limit: 20,
    },
    arrFilters: '',
    listNot: false
    
  }),
  async mounted() {
    //base
    const clientsSource = await this.$store.dispatch('getClientsSource', this.params);
    this.clientsSources = clientsSource.data.list;
    this.quantityList = clientsSource.data.total_num
  },
  methods: {

    //function filtration
    async reloadFilters(mod){
      if(mod !== 'pagination'){
        this.params.start = 0
      }
      this.arrFilters = this.searchData
      var arrFilters = await this.$store.dispatch('postFiltersClientsSource', {params: this.params, data: this.arrFilters})
      this.clientsSources = arrFilters.data.list
      this.quantityList = arrFilters.data.total_num
      if(this.quantityList == 0){
        this.listNot = true
      } else{
        this.listNot = false
      }
    },


    //search
    async searchBtn(data) {
      if(data !== undefined && data.load !== true){
        this.searchData = data.search
      }
      if(data.load !== true){
        this.reloadFilters('search');
      }
    },

    //paginations
    async pagination(data){
      this.params.start = data.start
      if(data.load !== true){
        this.reloadFilters('pagination')
      }
    }

  },
  components:{
    Pagination, Search
  }
  
}
</script>